import * as PIXI from 'pixi.js';
import Color from '../utils/Color';

export default class Curve {
  color = Color.BLACK;

  from = new PIXI.Point(0, 0);
  to = new PIXI.Point(0, 0);

  thickness = 1;

  curvature = 0;

  get alpha() {
    return this.color.getAlpha();
  }

  set alpha(value) {
    this.color.setAlpha(value);
  }

  getControlPoint() {
    const delta = {
      x: this.to.x - this.from.x,
      y: this.to.y - this.from.y,
    };
    const center = {
      x: this.from.x + delta.x / 2,
      y: this.from.y + delta.y / 2,
    };
    return new PIXI.Point(
      center.x - delta.y * this.curvature,
      center.y + delta.x * this.curvature
    );
  }

  draw(graphics) {
    graphics.lineStyle(
      this.thickness,
      Color.toNumber(this.color),
      this.color.getAlpha()
    );
    graphics.moveTo(this.from.x, this.from.y);
    if (this.curvature === 0) {
      graphics.lineTo(this.to.x, this.to.y);
    } else {
      const control = this.getControlPoint();
      graphics.quadraticCurveTo(control.x, control.y, this.to.x, this.to.y);
    }
  }
}
